import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://schteffann.de';
const DEFAULT_IMAGE = 'https://schteffann.de/Logo_Schteffann_505x125.png';
const SITE_NAME = 'Schteffann IT-Dienstleistungen';

const SEOHead = ({ title, description, keywords, ogImage, jsonLd }) => {
  const location = useLocation();
  const canonicalUrl = `${BASE_URL}${location.pathname}`;
  const image = ogImage || DEFAULT_IMAGE;

  useEffect(() => {
    document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (el) {
        el.setAttribute(attr, value);
      } else {
        el = document.createElement('meta');
        const parts = selector.match(/\[(\w+(?:-\w+)*)="([^"]+)"\]/);
        if (parts) {
          el.setAttribute(parts[1], parts[2]);
        }
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
    };

    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (el) {
        el.setAttribute('href', href);
      } else {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        el.setAttribute('href', href);
        document.head.appendChild(el);
      }
    };

    setMeta('meta[name="description"]', 'content', description);
    if (keywords) {
      setMeta('meta[name="keywords"]', 'content', keywords);
    }

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', canonicalUrl);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:site_name"]', 'content', SITE_NAME);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:locale"]', 'content', 'de_DE');

    setMeta('meta[property="twitter:title"]', 'content', title);
    setMeta('meta[property="twitter:description"]', 'content', description);
    setMeta('meta[property="twitter:url"]', 'content', canonicalUrl);
    setMeta('meta[property="twitter:image"]', 'content', image);
    setMeta('meta[property="twitter:card"]', 'content', 'summary_large_image');

    setLink('canonical', canonicalUrl);

    if (jsonLd) {
      const existingScript = document.querySelector('script[data-seo-page]');
      if (existingScript) {
        existingScript.textContent = JSON.stringify(jsonLd);
      } else {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-page', 'true');
        script.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(script);
      }
    }

    return () => {
      document.title = 'Schteffann IT-Dienstleistungen';
      const pageScript = document.querySelector('script[data-seo-page]');
      if (pageScript) pageScript.remove();
    };
  }, [title, description, keywords, canonicalUrl, image, jsonLd]);

  return null;
};

export default SEOHead;
